import { useEffect, useState } from 'react';

import useAuthStore from '@entities/auth/model/useAuthStore';
import { isMobileApp } from '@shared/utils/fcmToken';

/**
 * JWT 토큰 만료 여부 확인 (실제 만료만 판단)
 * - 자동 갱신 없이 사용자 "연장" 버튼으로만 갱신하므로, 만료된 경우에만 true
 */
function isTokenExpired(token) {
  if (!token) return true;

  try {
    const [, payload] = token.split('.');
    const decoded = JSON.parse(
      decodeURIComponent(
        atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      ),
    );

    const exp = decoded.exp;
    if (!exp) return true;

    const now = Math.floor(Date.now() / 1000);
    return exp < now;
  } catch {
    return true;
  }
}

/**
 * AuthBootstrap
 * - accessToken이 있고 아직 만료되지 않았으면 인증 확정
 * - 없거나 만료되었으면 로그아웃 상태로 확정 (자동 갱신 없음, 헤더 "연장"으로만 갱신)
 */
export default function AuthBootstrap({ children }) {
  const [isBootstrapping, setIsBootstrapping] = useState(true);

  useEffect(() => {
    const { accessToken, user, clearAuth, setBootstrapped } = useAuthStore.getState();

    if (accessToken && user && !isTokenExpired(accessToken)) {
      setBootstrapped();
      setIsBootstrapping(false);
      return;
    }

    if (!isMobileApp()) {
      const preventAutoLogin = sessionStorage.getItem('preventAutoLogin') === 'true';
      const isSessionActive = sessionStorage.getItem('isSessionActive') === 'true';
      const isRememberMe = localStorage.getItem('isRememberMe') === 'true';
      if (preventAutoLogin || (!isSessionActive && !isRememberMe)) {
        clearAuth();
        setBootstrapped();
        setIsBootstrapping(false);
        return;
      }
    }

    clearAuth();
    setBootstrapped();
    setIsBootstrapping(false);
  }, []);

  if (isBootstrapping) {
    return null;
  }

  return children;
}
